import React, { useState } from 'react';
import PaymentModal from '../PaymentModal';

//Import Components
import ShippingInfo from '../../Components/ui/ShippingInfo';
import Button from '../ui/Button';


const CheckoutForm = ({ totalAmount, isLoading, items }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    paymentType: 'order'
  });

  const orderItems = items.map(item => ({
    productName: item.name,
    productPrice: item.selectedSize.price,
    productSize: item.selectedSize,
    productQuantity: item.quantity,
    productImage: item.image
  }));

  // console.log(orderItems); // for debugging

  localStorage.setItem('orderItems', JSON.stringify(orderItems));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.length === 0) {
      alert('Please fill out the required details');
      return;
    }

    // Store order items when proceeding to payment
    localStorage.setItem('orderItems', JSON.stringify(orderItems));
    setShowPaymentModal(true);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };



  return (
    <>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
          />
        </div>
        <div>
          <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">Phone Number</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
          />
        </div>
        <div>
          <label htmlFor="address" className="block text-sm font-medium text-gray-700">Shipping Address</label>
          <textarea
            id="address"
            name="address"
            required
            value={formData.address}
            onChange={handleChange}
            rows="3"
            placeholder='e.g. Owerri, Imo State'
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
          />
        </div>

        {/* Info about shipping fee calculation method */}
        <ShippingInfo />

        <Button
          type="submit"
          variant='primary'
          disabled={isLoading}
          className="w-full disabled:bg-blue-300"
        >
          {isLoading ? 'Processing...' : 'Proceed to Payment'}
        </Button>
      </form>

      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => {
          setShowPaymentModal(false);
          // Remove orderItems if payment modal is closed without completing payment
          localStorage.removeItem('orderItems');
        }}
        amount={totalAmount}
        customerName={formData.name}
        customerEmail={formData.email}
        customerPhone={formData.phone}
        orderDetails={{
          orderDate: new Date(),
          paymentType: formData.paymentType,
          shippingAddress: formData.address,
          orderItems: orderItems // Pass orderItems to PaymentModal
        }}
      /> 
    </>
  );
};

export default CheckoutForm;